import React, { Component } from 'react';
import { addBotPics } from '../Firebase/TinqerPics';
/** eslint-disable */


require('./addBotpage.css');
require('../quill.css');
/***********FIREBASE Related ******************/
var firebase = require('firebase'), db = firebase.firestore(), secst = firebase.storage;
var fileStorage = firebase.app().storage("gs://tinqerappsfbbucket/");
//Secondary Storage Bucket for the Apps
var storageRef = fileStorage.ref();

/***********TEXT EDITOR -- QUILL ***********/
var Quill = require('quill'), counter = -1, editor;
//Toolbar options Quill
var toolbarOptions = [
    ['bold', 'italic', 'underline'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'align': [] }],
    ['image'],
    ['video']
];

//console.log(process.env.FIREBASE_STORAGE_BUCKET);

class AddBot extends Component {
    constructor(props) {
        super(props);
        this.state = {
            signedIn: false,
            editorContent: {},
            userUID: '',
            userEmail: '',
            username: '',
            dataRecieved: false
        };
    }

    componentWillMount() {
        var referThis = this;
        //Check if the user has already logged in, if so lead to their profile page. if not, set the check status to False.  
        firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                var docRef = db.collection("users").doc(user.email.toString());
                docRef.get().then(documents => {

                    if (documents && documents.exists) {
                        console.log("User Exists!");
                        // let unique_username = user.displayName.replace(/ /g, "_") + "_" + referThis.uniqueKeyCreator();
                        referThis.setState({
                            username: user.displayName.replace(/ /g, "_"),
                            signedIn: true,
                            userUID: user.uid,
                            userEmail: user.email
                        });

                        console.log("Starting Description Editor!");
                        document.title += "- Add Application";

                    } else {
                        //If the user does not exist: 
                        window.alert("Please update your profile!");
                        referThis.setState({
                            signedIn: false,
                            dataRecieved: true
                        });
                    }
                }).catch(err => {
                    console.log("AddBot - An Error Occured while getting user information  - " + err.code);
                }).then(() => {
                    //Checked if user is signed in or not. 
                    referThis.setState({
                        dataRecieved: true
                    });
                    //Initialize the editor
                    var container = document.getElementById('editor');
                    editor = new Quill(container, {
                        theme: 'snow',
                        placeholder: 'Describe Your Application....',
                        modules: {
                            toolbar: toolbarOptions
                        }
                    });
                });



            } else {
                referThis.setState({
                    signedIn: false,
                    dataRecieved: true
                });

            }
        }, function (error) {
            //Add a function where if there was an error, send an email to me 
            window.alert("There was an error: " + error.code + "\n Please try again later");
            console.log("Error Message: " + error.message);
            referThis.setState({
                signedIn: false
            });
        });
    }

    submitApp = () => {
        //Get all the necessary references - database and storage. 
        var docRef = db.collection("users").doc(this.state.userEmail.toString()).collection('applications');
        var commonCatalogPath = db.collection('applications');
        //var progressBarDiv = document.getElementById('fileUploadProgres');
        var fileUploadProgressName = document.getElementById('fileUploadProgressName');
        var progressBar = document.getElementById('progressBar');
        var linkInput = document.getElementById('linkInput').value, chatBotlink = document.getElementById('chatbot_solution').checked;

        var referThis = this, appName = document.getElementById('appName').value, proceed = true;

        if (appName === "") {
            document.getElementById("appTypeCard").style.border = "1px solid red";
            console.log("Name Error");
            proceed = false;
        }

        if (linkInput === "" && chatBotlink) {
            document.getElementById("linkInput").style.border = "1px solid red";
            proceed = false;
        }


        //1. Get the Radio Button Input 
        if (document.querySelector('input[name = "solpicker"]:checked') == null) {
            //Alert the user
            document.getElementById("appTypeCard").style.border = "1px solid red";
            console.log("Type Error");
            proceed = false;
        } else {
            var typeOfApp = document.querySelector('input[name = "solpicker"]:checked').id;
            //replace underscore with space in the id. and capitalize The Beginning of each word.
            typeOfApp = typeOfApp.replace(/_/g, " ").toLowerCase().replace(/(^| )(\w)/g, s => s.toUpperCase());
            console.log("Type Recieved.");
        }

        //2. Get the App Description 
        //var infoValue = JSON.stringify(editor.getContents());
        console.log(editor.getContents());


        //if all the required information is filled in above 
        if (proceed) {
            document.getElementById('errorMessage').innerText = '';

            //3. Get all the files. 
            var firstUploadedFiles = document.getElementById('fileUploadInput').files;
            //See which check boxes are checked. 
            var checkboxes = document.getElementsByName('fileCheckox');
            var checkBoxesChecked = [], neededFiles = [], fileCounter = -1;

            for (var i = 0; i < checkboxes.length; i++) {
                // And stick the checked ones into an array...
                if (checkboxes[i].checked) {
                    fileCounter += 1;
                    var index = checkboxes[i].id.lastIndexOf('_');

                    var fileIndex = checkboxes[i].id.substr(index + 1);
                    //The necessary file -- 
                    neededFiles[fileCounter] = firstUploadedFiles[fileIndex];

                    var fileNecessary = firstUploadedFiles[fileIndex];
                    console.log(fileIndex + " " + firstUploadedFiles[fileIndex]);
                    //Create the File Metata
                    var fileMetadata = {
                        customMetadata: {
                            'size': fileNecessary.size,
                            'name': fileNecessary.name,
                            'contentType': fileNecessary.type
                        }
                    };

                    console.log("Wokring on this file now: " + fileNecessary.name);

                    //upload file and metadata to the object -- users/emailID/applications/appName/
                    var uploadTask = storageRef.child('users/' + this.state.userEmail + '/applications/' + appName + '/' + fileNecessary.name)
                        .put(fileNecessary, fileMetadata);

                    uploadTask.on(secst.TaskEvent.STATE_CHANGED,
                        function (snapshot) {
                            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                            //Update the progress bar
                            fileUploadProgressName.innerText = "Uploading: " + fileNecessary.name + " -- " + progress + "%";
                            progressBar.style.width = progress + '%';
                            switch (snapshot.state) {
                                case firebase.storage.TaskState.PAUSED: // or 'paused'
                                    console.log('Upload is paused');
                                    break;
                                case firebase.storage.TaskState.RUNNING: // or 'running'
                                    console.log('Upload is running');
                                    break;
                            };
                        }, function (error) {
                            console.log("An error happened: " + error.code)
                        });


                    uploadTask.then(function (upSnapshot) {
                        if (upSnapshot.downloadURL === "" || upSnapshot.downloadURL == null) {
                            //File still hasn't been uploaded. 
                            proceed = false;
                        }
                        else {
                            //Upload has been successfull.. 
                            progressBar.style.backgroundColor = 'green';
                        }
                    });
                    checkBoxesChecked.push(fileIndex);
                }
            }

            console.log('... Files have been uploaded....');
            if (proceed) {
                //Set the data in database 
                var filesPath = storageRef.child('users/' + this.state.userEmail + '/applications/' + appName + '/');
                //Update the information in Database 
                var appDocRef = docRef.doc(appName);
                appDocRef.set({
                    appType: typeOfApp,
                    appName: appName,
                    description: JSON.stringify(editor.getContents()),
                    filesPath: filesPath.fullPath,
                    linkInput: linkInput,
                }, { merge: true }).catch((error) => {
                    //There was an error setting data
                    console.log("Error Setting App Data: " + error.code);
                }).then(function () {
                    //Include the app in the App Catalog 
                    commonCatalogPath.doc(appName).set({
                        appType: typeOfApp,
                        appName: appName,
                        userEmail: referThis.state.userEmail,
                        filesPath: filesPath.fullPath,
                        linkInput: linkInput,
                        dbPath: appDocRef.path.toString(),
                        username: referThis.state.username.toString()
                    }, { merge: true }).catch((error) => {
                        //There was an error setting data
                        console.log("Error Setting App Data: " + error.code);
                    }).then(function () {
                        //Successfull Completion of data submitssion. 
                        //Show the after message
                        document.getElementById('addBotPageAfterSubmission').style.display = "block";
                        window.location.replace(`/developers/${referThis.state.username}`);
                    });
                });
            }
        } else {
            document.getElementById('errorMessage').innerText = 'Please fill in all the required information!';
        }





        /*this.setState({
            editorContent: infoValue
        });
         Show Preview of the Editor 
        var previewQuill = new Quill('#preview', {
            readOnly: 'true',
            theme: 'snow',
            modules: {
                toolbar: false
            }
        });

        previewQuill.setContents(editor.getContents()); */



    }

    fileUploadTrigger = () => {
        //User has started updating files 
        var uploadedFiles = document.getElementById('fileUploadInput').files;
        //referThis = this;
        counter += 1;

        //If multiple files were uploaded, go through them. 
        if (uploadedFiles.length > 1) {
            //User has uploaded more than 1 file.
            console.log("More than 1 file uploaded!: " + uploadedFiles);
            let file, ul = document.getElementById('listOfFiles');
            for (var i = 0; i < uploadedFiles.length; i++) {
                //get File
                file = uploadedFiles[i];

                //create list item
                var li = document.createElement('li');
                li.classList.add('list-group-item', 'lgi');
                li.setAttribute('name', 'listId' + counter);
                li.id = 'list_item_files';
                //li.appendChild(document.createTextNode(file.name));

                var labelItem = document.createElement('label');
                labelItem.className = 'form-check-label fcl';
                labelItem.id = 'fileNameId';

                //Create a checkbox for the item. 
                var checkbox = document.createElement('input');
                checkbox.type = 'checkbox';
                checkbox.className = 'form-check-input fci';
                checkbox.id = 'listId_' + counter;
                checkbox.name = 'fileCheckox';
                checkbox.setAttribute('checked', true);

                labelItem.appendChild(checkbox);
                labelItem.appendChild(document.createTextNode(file.name));

                li.appendChild(labelItem);
                ul.appendChild(li);
                counter += 1;
            }

        } else {
            //Only 1 file uploaded. 
            var uploadedFile = document.getElementById('fileUploadInput').files[0];
            let ul = document.getElementById('listOfFiles');
            let li = document.createElement('li');
            li.className = 'list-group-item lgi';
            li.id = 'list_item_files';
            li.setAttribute('name', 'listId' + counter);
            let labelItem = document.createElement('label');
            labelItem.className = 'form-check-label fcl';
            labelItem.id = 'fileNameId';

            //Create a checkbox for the item. 
            let checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.className = 'form-check-input fci';
            checkbox.id = 'listId_' + counter;
            checkbox.name = 'fileCheckox';
            checkbox.setAttribute('checked', true);

            labelItem.appendChild(checkbox);
            labelItem.appendChild(document.createTextNode(uploadedFile.name));

            li.appendChild(labelItem);

            ul.appendChild(li);
        }
    }


    render() {
        while (!this.state.dataRecieved) {
            return (
                <div className="loadingDiv text-center">
                    <br />
                    <h3><i className="fab fa-pied-piper-alt" id='spinner' ></i></h3>
                    <br />
                </div>
            );
        }
        if (this.state.signedIn) {
            return (
                <div className="container addBotPageContainer">
                    <div className="addBotFormBeforeSubmission">

                        <h1 className="text-center">Add Application</h1>

                        <hr style={{ backgroundColor: 'blue' }} />
                        <div className="card" id="appTypeCard">
                            <div className="card-header" style={{ background: 'transparent' }}>
                                <input type='text' id='appName' placeholder="Name Of App..." className='form-control-plaintext' />
                            </div>
                            <h4 className="text-center card-header">Select App Type: </h4>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item lgi">
                                    <label>
                                        <input type="radio" name="solpicker" id="chatbot_solution" /> &nbsp;
                                        Chat Bot
                                </label>
                                </li >
                                <li className="list-group-item lgi">
                                    <label>
                                        <input type="radio" name="solpicker" id="computer_vision_solution" /> &nbsp;
                                        Computer Vision Solution
                                </label>
                                </li>
                                <li className="list-group-item lgi">
                                    <label>
                                        <input type="radio" name="solpicker" id="IOT_Solution" /> &nbsp;
                                        IOT Solution
                                </label>
                                </li>
                                <li className="list-group-item lgi">
                                    <label>
                                        <input type="radio" name="solpicker" id="data_analytics_solution" /> &nbsp;
                                        Data Forecasting and Predictions Software
                                </label>
                                </li>
                                <li className="list-group-item lgi">
                                    <label>
                                        <input type="radio" name="solpicker" id="face_recognition_solution" /> &nbsp;
                                            Face Recognition
                                </label>
                                </li>
                                <li className="list-group-item lgi">
                                    <label>
                                        <input type="radio" name="solpicker" id="speaker_recognition_solution" /> &nbsp;
                                        Speaker Recognition
                                </label>
                                </li>
                            </ul>
                        </div>
                        <br />
                        <div className="editPlace">
                            <div id="editor">
                            </div>
                        </div>
                        <br />
                        {/*<div id="preview" >
                    </div> */}
                        <br />

                        <div className="appLinkContainer">
                            <h4 className="text-center">Link To App</h4>

                            <input type='text' id="linkInput" className="form-control"
                                placeholder="(optional)"
                            />
                            <br />
                            <h4 className="text-center">Upload Files</h4>
                            <div className="card fileUploadCard">
                                <div className="card-block">
                                    <ul className="list-group list-group-flush" id="listOfFiles">

                                    </ul>
                                </div>
                                <div className="card-footer text-center" style={{ backgroundColor: "transparent" }}>
                                    <div className="upload-buttn-wrapper">
                                        <label className="btn btn-lg myLabel" id="fileUploadButton" >
                                            <input type="file" id="fileUploadInput" required={true} multiple={true}
                                                onChange={() => this.fileUploadTrigger()}
                                            />
                                            <span><i className="fas fa-upload"></i></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <small>These files will be scanned for viruses and malware. If you need an exception, please contact us.</small>
                            <br />
                            <small id="fileUploadProgressName"></small>
                            <div className="progress" id="fileUploadProgres" style={{ backgroundColor: 'transparent' }}>
                                <div className="progress-bar" id="progressBar" role="progressbar" aria-valuemin="0" aria-valuemax="100" ></div>
                            </div>
                            <br />
                        </div>

                        <button type='button' className="btn btn-lg" id="submitButton" onClick={() => this.submitApp()}>
                            Submit
                    </button>
                        <br />
                        <small id="errorMessage"></small>
                    </div>
                    <div id="addBotPageAfterSubmission" style={{ display: 'none' }}>
                        <h3 className="text-center">Cranking some gears to process your upload...</h3>
                    </div>
                </div>

            );
        } else {
            return (
                <div>
                    <div className="container">
                        <div className="top_banner">
                            <br /><br />
                            <h1 className="text-center">Tinqer App Sharing Platform</h1>
                            <h4 className="text-center">Allow your vision to reach more people!</h4>
                        </div>
                        <div className="potential_banner text-center">
                            <h2>Find Your Potential</h2>
                            <hr id="potential_line" />
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="card potentialCard">
                                        <img alt="potential_one" className="card-img-top" id="potential_one_image" src={addBotPics.money_illustration} />
                                        <div className="card-body">
                                            <span className="badge badge-primary">Coming Soon</span>
                                            <h4 className="text-center">Earn Extra Income!</h4>
                                            <p>
                                                Once your App or Bot is approved and placed on the Tinqer Catalog, businesses and people will be able to rent your product for as long as they like. You will earn money everytime someone rents your product.
                                                </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="card potentialCard">
                                        <img className="card-img-top" alt="potential_one" id="potential_one_image" src={addBotPics.deskLady} />
                                        <div className="card-body">
                                            <h4 className="text-center">Impact Businesses!</h4>
                                            <p>
                                                When a business rents your App or Bot, it will impact how their daily operations and the lives of their customers.
                                                </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="card potentialCard">
                                        <img className="card-img-top" alt="potential_one" id="potential_one_image" src={addBotPics.team_illustration} />
                                        <div className="card-body">
                                            <h4 className="text-center">Reach More Audience!</h4>
                                            <p>
                                                Worried about getting clients to your amazing App or Bot? Don't worry. As soon as your product is placed on the Tinqer Catalog, it will be seen by multiple businesses and persons every single day!
                                                </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <br />
                        <div className="howItWorks text-center">
                            <h2>How It Works</h2>
                            <hr id="potential_line" />
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="card howItWorksCard">
                                        <img alt="how_it_works" className="card-img-top" id="how_it_works_image" src={addBotPics.reserve_spot_success} />
                                        <div className="card-body">
                                            <h4 className="text-center">1. Apply For a Spot Below!</h4>
                                            <p>
                                                In order to get placed on our page, you must have a working product that is reliable and trustworthy.
                                                </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="card howItWorksCard">
                                        <img alt="how_it_works" className="card-img-top" id="how_it_works_image" src={addBotPics.camera_access_pic} />
                                        <div className="card-body">
                                            <h4 className="text-center">2. Upload Your Product!</h4>
                                            <p>
                                                Once you get approved, you can link/upload your App / Bot to our database.
                                                </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="card howItWorksCard">
                                        <img alt="how_it_works" className="card-img-top" id="how_it_works_image" src={addBotPics.easy_money_pic} />
                                        <div className="card-body">
                                            <span className="badge badge-primary">Coming Soon</span>
                                            <h4 className="text-center">3. Get Recognition and Earn Money!</h4>
                                            <p>
                                                Launch your product and make other businesses' lives better and easier!
                                                </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card applyBotCard">
                            <div className="card-body">
                                <h1 className="card-title">Share your Idea or Product!</h1>
                                <div className="card-text">
                                    Add your own App or Bot to the collection and reach thousands of people/businesses around the world! <br />
                                </div>
                                <hr />
                                <form style={{ paddingRight: '30px', paddingLeft: '30px' }}>
                                    <input type="text" className="form-control addBotInput" id="nameInput" placeholder="Full Name" required />
                                    <br />
                                    <input type="text" className="form-control addBotInput" id="businessNameInput" placeholder="Business Name (optional)" required /><br />
                                    <input type="tel" className="form-control addBotInput" id="contactNumberInput" placeholder="Contact Number" required /><br />
                                    <input type="email" className="form-control addBotInput" id="emailInput" placeholder="Email Address" required /><br />
                                    <input type="url" className="form-control addBotInput" id="businessWebsiteInput" placeholder="Website URL (optional)" /><br />
                                    <textarea className='form-control addBotInput' id='summaryArea' rows='3' placeholder="Short Description of Bot" required></textarea><br />
                                </form>
                                <button className="btn" id='contactUsButton'
                                    onClick={() => this.contactUs()}
                                >Apply For A Spot!</button>
                                <br />
                                <small id='errorArea'> </small>
                                <small>We will get back to you within 24 Hours!</small>
                            </div>
                        </div>
                    </div>
                </div >
            );
        }
    }
}

export default AddBot;


// WEBPACK FOOTER //
// ./src/AddBot/AddBot.js